import {useModifier} from 'modules/modifier/modifierStore';

export const fetchLocalFeatureFlags = () => {
  return useModifier.getState().featureFlags || {};
};
